import script from "./PrivatePlanPurchaseDetailsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivatePlanPurchaseDetailsPopup.vue?vue&type=script&setup=true&lang=js"

import "./PrivatePlanPurchaseDetailsPopup.vue?vue&type=style&index=0&id=938ee8da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-938ee8da"]])

export default __exports__